import { render } from "./WithTypes.vue?vue&type=template&id=5269e437"
import script from "./WithTypes.vue?vue&type=script&lang=js"
export * from "./WithTypes.vue?vue&type=script&lang=js"
script.render = render

export default script